import AcceptanceReviewFormCreate from 'features/AcceptanceReview/pages/Create';
import Layout from 'layout';
import { Can } from 'components/Can';
import { LayoutProvider } from '../layout/context/layoutcontext';

export default function AcceptanceReviewFormCreatePage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
        }}
      >
        <Can do="create" on="acceptance_review">
          <AcceptanceReviewFormCreate />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}
